function doProductBundleCarousel() {
  if (customElements.get("productbundle-carousel")) return null;

  class ProductBundleCarousel extends HTMLElement {
    constructor() {
      super();
      this.addToCartBtn = this.querySelector(".pbc-add-wrapper");
      this.carouselProductsWithVariants = this.querySelectorAll(
        `product-card[data-only-default-variant="false"] select.product-card-variants`
      );
      this.init();
    }

    init() {
      this.addToCartBtn.addEventListener("click", (e) => {
        e.preventDefault();
        if (this.addToCartBtn.dataset.status === "0") {
          this.changeAddToCartDesign();
          this.addBundleToCart();
        }
      });
      this.doGlide();
      this.handleProductCardSelect();
    }

    doGlide() {
      new Glide(".productBundleCarousel_glide", {
        rewind: false,
        perView: 6,
        gap: 20,
        hoverpause: false,
        swipeThreshold: 9999999,
        arrow: true,
        dragThreshold: false,
        breakpoints: {
          1500: {
            perView: 4,
          },
          990: {
            perView: 3,
          },
          750: {
            perView: 2,
          },
        },
      }).mount();
    }

    changeAddToCartDesign() {
      this.addToCartBtn.setAttribute("data-status", 1);
    }

    /**
     * Mutates the dom, by selecting the specified options values
     * and triggers the AddToCart main form
     */
    addBundleToCart() {
      const mainAddToCartForm = document.querySelector(
        '.section-product-top-fold form[action="/cart/add"] '
      );

      setTimeout(() => mainAddToCartForm.submit(), 1000);
    }

    handleProductCardSelect() {
      const mainProductBundleOptions = document.querySelectorAll(
        ".section-product-top-fold .variant-radios .product-form__input"
      );

      this.carouselProductsWithVariants.forEach((cardSelector, index) => {
        cardSelector.addEventListener("change", () => {
          const value = cardSelector.value;
          const targetedOptionValue = mainProductBundleOptions[
            index
          ].querySelector(`input[type="radio"][value="${value}"]`);

          if (value && targetedOptionValue)
            $(targetedOptionValue).trigger("click");
        });
      });
    }
  }
  customElements.define("productbundle-carousel", ProductBundleCarousel);
}
doProductBundleCarousel();
